module.exports = __webpack_public_path__ + "static/media/the_beat_from_palookaville.81179ca6.png";